module.exports = __webpack_public_path__ + "static/media/05660012-0hR0wSgs.3d482df0.JPG";